// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React, {useMemo, useCallback} from 'react';
import cn from 'classnames';
import {Text} from '../text';
import {Icon} from '../icon';
import * as cns from './checkbox.module.less';

export function Checkbox({
    checked,
    className,
    label,
    id: _id,
    disabled,
    on_change,
    check_placement='right',
    no_background,
    ico,
})
{
    const id = useMemo(()=>
        _id || 'ea_checkbox_'+Math.random().toString(), [_id]);
    const handle_change = useCallback(()=>
        on_change?.(!checked), [on_change, checked]);
    const classes = cn(cns.root, {
        [cns.root__left_check]: check_placement=='left',
        [cns.root__no_bg]: !!no_background,
    }, className);
    return <div className={classes}>
      <input id={id} checked={checked} type="checkbox" onChange={handle_change}
        disabled={disabled} className={cns.input}/>
      {!!label && <label htmlFor={id} className={cns.label}>
        {ico&&<Icon className={cns.ico} ico={ico} size="s"
          color={checked ? 'light' : 'secondary'}/>}
        <Text.xs className={cns.text} secondary={!checked}>{label}</Text.xs>
      </label>}
    </div>;
}
